import { FormGroup } from '@angular/forms';

export function currencyValidator (group: FormGroup){
  if (!/^[0-9]{1,3}(?:,?[0-9]{3})*(\.[0-9]{1,2})?$/.test(group.value)) {
    return {
      notCurrency: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/currency.ts